import { render } from "./BooleanSwitchRenderer.vue?vue&type=template&id=4b14a4e8&scoped=true&ts=true"
import script from "./BooleanSwitchRenderer.vue?vue&type=script&lang=ts"
export * from "./BooleanSwitchRenderer.vue?vue&type=script&lang=ts"

import "./BooleanSwitchRenderer.vue?vue&type=style&index=0&id=4b14a4e8&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b14a4e8"]])

export default __exports__